import type { KeywordDefinition } from 'ajv';
import { NumberProperty } from 'shared';

const removeStartHyphenOrPlus = (numberValue: string): string => {
  if (numberValue.startsWith('-')) {
    return numberValue.substring(1);
  }
  if (numberValue.startsWith('+')) {
    return numberValue.substring(1);
  }
  return numberValue;
};

const removeFirstPeriod = (numberValue: string): string => {
  if (numberValue.includes('.')) {
    return numberValue.replace('.', '');
  }
  return numberValue;
};

const stringForDigitsValidation = (numberValue: string): string => {
  return removeFirstPeriod(removeStartHyphenOrPlus(numberValue));
};

export const digitsRange: KeywordDefinition = {
  keyword: 'digitsRange',
  type: 'string',
  validate(schema: NumberProperty['digitsRange'], data: string) {
    if (schema == null) {
      return true;
    }
    const convertedValue = stringForDigitsValidation(data);
    if (schema.min != null && convertedValue.length < schema.min) {
      return false;
    }
    if (schema.max != null && convertedValue.length > schema.max) {
      return false;
    }
    return true;
  },
};
